import InfoScreens from './InfoScreens';
import useStickyState from 'hooks/useStickyState';

import {
  Grid,
  Alert,
  Button,
} from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';

function InfoScreensSticky({ data }) {
  const currentURLPath = window.location.pathname;
  const [showContent, setShowContent] = useStickyState(false, currentURLPath);

  const ShowSlides = () => {
    const onClick = () => setShowContent(false)
    const hide = () => setShowContent(true)
    return (
      <Grid sx={{ mb: 3 }}>
        <Alert variant="outlined" severity="info"
          action={showContent ? (
            <Button onClick={onClick}>Show</Button>
          ) : (
            <Button onClick={hide}>Hide</Button>
          )}>
          How it works
        </Alert>
      </Grid>
    )
  }

  const buttonClicked = () => {
    setShowContent(true)
  }

  return (
    <>
      <Grid item xs={12} mb={3}>
        <MainCard>
          {showContent ? '' : <InfoScreens data={data} onClick={buttonClicked} />}
          <ShowSlides />
        </MainCard>
      </Grid>
    </>
  )
}

export default InfoScreensSticky;